import { CreateInvoiceType, CreateInvoicePayload } from '../types';

const convertCreateInvoiceRequestPayload = (data: CreateInvoiceType): CreateInvoicePayload => ({
  _service_request_id: data.serviceRequestId,
  _invoice_number: data.invoiceNumber,
  _invoice_date: data.invoiceDate,
  _invoice_amount: data.invoiceAmount.toString(),
  _invoice_file: data.invoiceFile,
  _description: data.description,
});

export default convertCreateInvoiceRequestPayload;
